export const staffList = (state) => state.staffList;
